module.exports = __webpack_public_path__ + "static/img/lz4.90da040.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lz4.png
// module id = W+CY
// module chunks = 6